import { render } from "./DirectoryMember.vue?vue&type=template&id=489829d1"
import script from "./DirectoryMember.vue?vue&type=script&lang=js"
export * from "./DirectoryMember.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__